import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiCallingV2Service, API_CONFIG } from '@zayan-erp/shared';

/** An email domain whose users count as internal. */
export interface TrustedDomain {
  id: string;
  domain: string;
  createdAt: string;
  createdBy: string | null;
  lastModified: string | null;
  updatedBy: string | null;
}

/** System Owner only; the API answers 403 to everyone else. */
@Injectable({
  providedIn: 'root'
})
export class TrustedDomainService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  #url = `${this.#apiConfig.baseUrlV2}/trusted-domains`;

  getTrustedDomains(): Observable<TrustedDomain[]> {
    return this.#http
      .getData<TrustedDomain[]>(this.#url, { showLoader: false, showMessage: false })
      .pipe(map((domains: TrustedDomain[] | null) => domains ?? []));
  }

  addTrustedDomain(domain: string): Observable<TrustedDomain> {
    return this.#http.postData<TrustedDomain>(
      this.#url,
      { showLoader: false, showMessage: true, message: 'Trusted domain added' },
      { domain }
    );
  }

  updateTrustedDomain(id: string, domain: string): Observable<TrustedDomain> {
    return this.#http.putData<TrustedDomain>(
      `${this.#url}/${id}`,
      { domain },
      { showLoader: false, showMessage: true, message: 'Trusted domain updated' }
    );
  }

  removeTrustedDomain(id: string): Observable<void> {
    return this.#http.deleteData<void>(`${this.#url}/${id}`, {
      showLoader: false,
      showMessage: true,
      message: 'Trusted domain removed'
    });
  }
}
